 <template>
    <div>
        <!-- Multi select access points table -->
       
                       <v-card v-if="multi" flat>
                           
                <v-toolbar flat class="primary">
                    <h1 class="headline white--text">SEARCH ACCESS POINTS</h1>
                </v-toolbar>
                <v-card-text>
                 <v-container grid-list-xs>
                    <v-layout wrap>
                        <v-text-field v-model="search2"
                                      append-icon="search"
                                      label="Search"
                                      single-line
                                      hide-details
                                      max-width="50px"
                                      class="pa-3"
                                      clearable></v-text-field>
                    </v-layout>
                    <v-data-table v-model="selected"
                                  :headers="headers2"
                                  :items="accessPoints"
                                  :pagination.sync="pagination"
                                  select-all
                                  :search="search2"
                                  item-key="id"
                                  class="elevation-1">
                        <template v-slot:headers="props">
                            <tr>
                                <th>
                                    <v-checkbox :input-value="props.all"
                                                :indeterminate="props.indeterminate"
                                                primary
                                                hide-details
                                                @click.stop="toggleAll"></v-checkbox>
                                </th>
                                <th v-for="header in props.headers"
                                    :key="header.text"
                                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                    @click="changeSort(header.value)">
                                    <v-icon small>arrow_upward</v-icon>
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr :active="props.item.flag" @click="clearAndSetMultiFlags(props.item.id)">
                                <td>
                                    <v-checkbox :input-value="props.item.flag"
                                                primary
                                                hide-details></v-checkbox>
                                </td>
                                <td class="text-xs-center">{{props.item.name}}</td>
                                <td class="text-xs-center">{{props.item.description}}</td>
                            </tr>
                        </template>
                    </v-data-table>
                     <v-card-actions>
                        <v-spacer></v-spacer>
                          <v-btn color="primary" round @click="onSelection()">Cancel</v-btn>
                          <v-btn color="primary" round @click="onSelection()">Done</v-btn>
                    </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>

               <!-- Single select access points table -->
       
                       <v-card v-if="!multi" flat>
                           
                <v-toolbar flat class="primary">
                    <h1 class="headline white--text">SEARCH ACCESS POINTS</h1>
                </v-toolbar>
                <v-card-text>
                 <v-container grid-list-xs>
                    <v-layout wrap>
                        <v-text-field v-model="search2"
                                      append-icon="search"
                                      label="Search"
                                      single-line
                                      hide-details
                                      max-width="50px"
                                      class="pa-3"
                                      clearable></v-text-field>
                    </v-layout>
                    <v-data-table v-model="selected"
                                  :headers="headers2"
                                  :items="accessPoints"
                                  :pagination.sync="pagination"
                                  select-all
                                  :search="search2"
                                  item-key="id"
                                  class="elevation-1">
                        <template v-slot:headers="props">
                            <tr>
                                <th>
                        
                                </th>
                                <th v-for="header in props.headers"
                                    :key="header.text"
                                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                    @click="changeSort(header.value)">
                                    <v-icon small>arrow_upward</v-icon>
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr :active="props.item.flag" @click="clearAndSetFlags(props.item.id)">
                                <td>
                                    <v-checkbox :input-value="props.item.flag"
                                                primary
                                                hide-details></v-checkbox>
                                </td>
                                <td class="text-xs-center">{{props.item.name}}</td>
                                <td class="text-xs-center">{{props.item.description}}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                          <v-btn color="primary" round @click="onSelection()">Cancel</v-btn>
                          <v-btn color="primary" round @click="onSelection()">Done</v-btn>
                    </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
         </div>
</template>
<!--////////////////////////////////////////////////////////////////////-->
<script>
    import Api from "@/services/Api";
    import format from "date-fns/format";

    export default {
        components: {
        },
        props: [ "accesspointsearchmodal", "multi", "preselected"
               ],
        data: function () {
            return {
                multi: true,
                accessPoints: [],
                selected: [],
                pagination: {},
                headers2: [
                    {
                        text: "Name",
                        align: "center",
                        value: "name"
                    },
                    {
                        text: "Description",
                        align: "center",
                        value: "description"
                    }
                ],
                search2: '',
            };
        },
        created() {
            this.initialize();
        },
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////
        methods: {
            initialize() {
               this.fetchAccessPoints();
               this.selected= this.preselected           
               
            },
            onSelection(){
                let proceed =true
                if(this.selected.length==0){
                    this.$emit('accessPointSelected', this.selected=[]) 
                }if (proceed == true) {
                    this.$emit('accessPointSelected', this.selected)  
                }
            },
            clearAndSetFlags(id) { 
                for(let i=0;i<this.accessPoints.length;i++) {
                    this.accessPoints[i].flag = false;
                    if(this.accessPoints[i].id == id) {
                        this.accessPoints[i].flag = true;
                        this.selected = [];
                        this.selected.push(this.accessPoints[i])
                    }
                }
            },
            clearAndSetMultiFlags(id) {
                for(let i=0;i<this.accessPoints.length;i++) {
                    if(this.accessPoints[i].id == id) {
                        if(this.accessPoints[i].flag) {
                            for(let k=0;k<this.selected.length;k++) {
                                if(this.selected[k].id == this.accessPoints[i].id) {
                                     this.selected.splice(k, 1);
                                     break;
                                }
                            }  
                            this.accessPoints[i].flag = false;
                        }
                        else {
                            this.selected.push(this.accessPoints[i])
                            this.accessPoints[i].flag = true;
                        }
                    }
                }

            },
             toggleAll() {
                if (this.selected.length) this.selected = []
                else this.selected = this.accessPoints.slice()
            },
            randomMethod() {
                if(!this.multi) {
                    for(let i=0; i<this.accessPoints.length; i++){
                        this.accessPoints[i].flag = false;
                        if(typeof(this.selected[0]) != 'undefined'){
                            if(this.accessPoints[i].id == this.selected[0].id){
                                this.accessPoints[i].flag = true;
                            }
                        }
                    }
                }  
                else {
                    for(let i=0; i<this.accessPoints.length; i++){
                        this.accessPoints[i].flag = false;
                        for(let j=0; j<this.selected.length; j++) {
                            if(typeof(this.selected[j]) != 'undefined'){
                                if(this.accessPoints[i].id == this.selected[j].id) {
                                    this.accessPoints[i].flag = true;
                                }
                            }       
                        }
                    }
                }
            },
            changeSort(column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column
                    this.pagination.descending = false
                }
            },
            fetchAccessPoints(){
            Api()
             .get('/accessPoints/getall')
             .then(response=>{
              this.accessPoints=response.data      
               this.randomMethod();     
              });
            },         
        }
    };
</script>
<style>

</style>
